// extracted by mini-css-extract-plugin
export default {"ResizeHandleInner":"ResizeHandle_ResizeHandleInner__oiVv1","ResizeHandleOuter":"ResizeHandle_ResizeHandleOuter__YnkrL","Icon":"ResizeHandle_Icon__wFvxx"};